import { Box, Container, Heading, Text, VStack } from "@chakra-ui/react"
import CallToAction from "../components/CallToAction"
import Footer from "../components/Footer"

const problems = [
  {
    title: "Funding gap",
    body: "The UK government aims for net zero by 2050, yet 1 million homes need retrofitting each year, with a £250 billion price tag. Current funding falls far short, leaving a massive investment gap."
  },
  {
    title: "Unclear returns",
    body: "Investors cannot confidently allocate capital at the portfolio level because financial returns and performance outcomes are uncertain."
  },
  {
    title: "Hard to prioritise",
    body: "Asset owners struggle to know where to direct retrofit investment without clear predictions of ROI."
  },
  {
    title: "Manual, slow processes",
    body: "Surveys and audits are expensive, time-consuming, inconsistent, and capacity-limited."
  }
]

const About: React.FC = () => {
  return (
    <Box>
      <Container maxW="container.sm" centerContent>
        <Heading as="h1" size="5xl" textAlign={["center", "left"]} mt={16}>
          About
        </Heading>

        <VStack gap={8} maxW="60vw" py={20} align="start">
          <Text>
            Amandeep and Thomas met at the Carbon13 Venture Builder and quickly
            realised they shared a frustration: the barriers to scaling home
            retrofit were enormous.
          </Text>
          <Text>
            Thomas had decided to retrofit his own home after receiving an
            energy bill estimate of £11,000 per year from his energy company.
            He spent 95% of his time on research and only 5% on installation.
            Even then, the ROI wasn't clear to him or to his neighbours
            when he tried to encourage them to do the same.
          </Text>
          <Text>
            Amandeep, an architect leading retrofit strategy for 30,000 homes,
            faced a different challenge: he struggled to attract investors
            because he lacked the data and tools to prove the outcomes needed
            to make the business case.
          </Text>

          <Heading as="h2" size="2xl" pt={4}>
            What's the problem?
          </Heading>

          <VStack gap={6} align="start" w="full">
            {problems.map((p) => (
              <Box key={p.title}>
                <Text fontWeight="bold" mb={1}>
                  {p.title}
                </Text>
                <Text>{p.body}</Text>
              </Box>
            ))}
          </VStack>

          <Text fontSize="xl" fontWeight="bold" pt={4}>
            This is why GreenFlip exists.
          </Text>
          <Text>
            GreenFlip transforms energy upgrades into clear, investable
            outcomes. We model outcomes from tech-first retrofit, match
            funding, and quantify returns through:
          </Text>
          <VStack align="start" gap={1} pl={4}>
            {["Rental yield uplift", "Asset value appreciation", "IRR modelling", "Energy bill savings"].map((item) => (
              <Text key={item}>· {item}</Text>
            ))}
          </VStack>
          <Text>
            We turn retrofit into a predictable, scalable investment,
            helping investors, asset owners and landlords make smarter,
            faster, data-driven decisions.
          </Text>
        </VStack>
      </Container>
      <CallToAction />
      <Footer />
    </Box>
  )
}

export default About
